// Fetch Request
import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;
  const dynamicBanner = values?.dynamicBanner?.length > 0 ? JSON.stringify(values.dynamicBanner) : JSON.stringify([]);
  
  const query = `
    query (
      $id: Int,
      $title: String,
      $content: String,
      $dynamicBanner: String,
    ) {
      updateBannerSettings (
        id: $id,
        title: $title,
        content: $content,
        dynamicBanner: $dynamicBanner,
      ) {
          status
      }
    }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: {
        ...values,
        title: values?.dynamicBanner?.[0]?.title,
        content: values?.dynamicBanner?.[0]?.content,
        dynamicBanner
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateBannerSettings.status === "success") {
    showToaster({ messageId: 'updateBannerSettings', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateBannerSettingsFailed', toasterType: 'error' })
  }

}

export default submit;
